import firehydrantAPI from 'helpers/firehydrantAPI';
import { useMutation } from 'react-query';

export const useCreateSignalStream = (options) =>
  useMutation(
    (params) => firehydrantAPI.post('signals_stream', params),
    options,
  );
